module.exports = __webpack_public_path__ + "static/meledia.ccf82e5d.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/meledia.webp
// module id = 444
// module chunks = 23899280101116